import {and, comparison, eq, or, le} from 'rsql-builder';
import {between, like} from '@/lib/custom-rsql-operators';
import {Comparison} from 'rsql-builder/dist/comparison';
import dayjs from 'dayjs';

export const FilterUtils = {
  methods: {
    /**
     * @param attributeName String
     * @param dates Array<String>
     */
    buildDateTimeFilter(attributeName, dates) {
      let filter = null;

      if (attributeName) {
        let date1 = dates[0];
        let date2 = dates[1];

        if (date1 != null) {
          if (date2 == null) {
            date2 = date1;
          }
          if (date1.length === 10) {
            date1 = dayjs(date1).startOf('day').format();
          }
          if (date2.length === 10) {
            date2 = dayjs(date2).endOf('day').format();
          }

          filter = comparison(attributeName, between(date1, date2));
        } else if (date2 != null) {
          if (date2.length === 10) {
            date2 = dayjs(date2).endOf('day').format();
          }
          filter = comparison(attributeName, le(date2));
        }
      }

      return filter;
    },

    /**
     * @param attributeName String
     * @param dates Array<String>
     */
    buildDateFilter(attributeName, dates) {
      let filter = null;

      if (attributeName) {
        let date1 = dates[0];
        let date2 = dates[1];

        if (date1 != null) {
          if (date2 != null) {
            filter = comparison(attributeName, between(date1, date2));
          } else {
            filter = comparison(attributeName, eq(date1));
          }
        } else if (date2 != null) {
          filter = comparison(attributeName, le(date2));
        }
      }

      return filter;
    },
    /**
     * @param searchText String
     * @param attributeNames Array<String>
     */
    buildSearchFilter(searchText, attributeNames) {
      let filter = null;

      if (searchText && attributeNames) {
        if (!Array.isArray(attributeNames)) {
          attributeNames = [attributeNames];
        }

        attributeNames = attributeNames
          .filter(attributeName => typeof attributeName === 'string')
          .map(attributeName => attributeName.trim())
          .filter(attributeName => attributeName.length > 0)
        ;

        if (attributeNames.length > 0) {
          filter = [];

          for (let searchPart of searchText.split(' ')) {
            searchPart = searchPart.trim();
            if (searchPart) {
              filter.push(
                or(...attributeNames.map(attributeName => comparison(attributeName, like(searchPart))))
              )
            }
          }

          filter = and(...filter);
        }
      }

      return filter;
    },

    buildFilterString(inputFilters) {
      let filterArray = [];

      if (Array.isArray(inputFilters)) {
        filterArray = inputFilters;
      } else if (inputFilters instanceof Comparison || typeof inputFilters === 'string') {
        filterArray = [inputFilters];
      } else if (inputFilters != null && typeof inputFilters === 'object') {
        for (let key of Object.keys(inputFilters)) {
          if (Object.prototype.hasOwnProperty.call(inputFilters, key)) {
            let value = inputFilters[key];
            if (value != null) {
              filterArray.push(comparison(key, eq(value)))
            }
          }
        }
      }

      return and(...filterArray.filter(value => value != null));
    }
  }
};
